<template>
    <div class="cart-container">
        <el-tooltip effect="light" placement="top" trigger="hover" content="Add to Cart" v-if="!isAddedToCart">
            <el-button class="add-to-cart submit-btn" :class="{ 'is-icon': isIconOnly}" @click.stop="addToCart">
                <img src="/img/icons/white-bag.svg" alt="add-to-cart-icon" aria-label="add to cart icon"
                     class="cart-icon"/>
                <span v-if="!isIconOnly">ADD TO CART</span>
            </el-button>
        </el-tooltip>
        <el-tooltip
                v-else
                effect="dark"
                placement="top"
                trigger="hover"
                content="Added To Cart">
            <el-button class="add-to-cart submit-btn added" :class="{ 'is-icon': isIconOnly}">
                <i class="el-icon-sell"></i>
                <span v-if="!isIconOnly">ADDED TO CART</span>
            </el-button>
        </el-tooltip>

    </div>
</template>

<script>
    import progress from "nprogress";
    import {mapGetters} from "vuex";

    export default {
        name: "AddToCartComponent",
        computed: {
            ...mapGetters('cart', ['getCart']),
            isAddedToCart() {
                return !!this.getCart.find(cart => cart.details.id === this.product.id);
            }
        },
        props: {
            product: {
                type: Object,
                required: true
            },
            isIconOnly: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            async addToCart() {
                progress.start();
                await this.$store.dispatch("cart/add", this.product);
                progress.done();
            },
        }
    }
</script>

<style lang="scss">
    .el-tooltip__popper.is-light {
        border-color: #ccc!important;
    }
    .cart-container {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        .add-to-cart {
            span {
                font-family: "Work Sans", sans-serif !important;
            }

            &:not(:last-child) {
                margin-right: 25px;
            }
        }

        .cart-icon {
            width: 15px;
            height: 15px;
            margin-right: 15px;
        }

        .el-button {
            background: lighten(#11233f, 20%);
            transition: all .3s linear;
            border-radius: 45px;
            border: 1px solid #11233f;
            padding: 10px 20px;
            color: #fff;
            font-weight: 600;
            font-size: 0.9em;

            &.is-icon {
                padding: 0 !important;
                width: 40px;
                height: 40px;
                line-height: 25px;
                text-align: center;

                & > span {
                    justify-content: center;
                }
                img {
                    margin-right: 0;
                }
            }

            &:hover, &:focus {
                background: #11233f;
                border-color: #11233f !important;
                color: #fff;
            }

            & > span {
                display: flex;
                justify-content: space-between;
            }
        }
    }
</style>
